
<template>
  <div>
    <OrderResume solution="wholesale" :order="order"></OrderResume>
    <v-checkbox v-model="terms" color="green" label="Confirmo as informações do pedido" :rules="[...required]"></v-checkbox>
  </div>
</template>

<script>
import validations from "@/mixins/validations";

export default {
  name: 'FinishWholesaleOrder',
  mixins: [ validations ],
  components:{
    OrderResume: () => import("@/components/create_order/shared/OrderResume.vue")
  },
  props: {
    order: {
      type: [Object],
    },
  },
  data(){
    return {
      terms: false,
    }
  },
}
</script>